export const modalPaperStyle = {
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "90vw", md: "45vw" },
  position: "absolute",
};

export const scrollStyles = {
  height: "100%",
  maxHeight: "98vh",
  overflowX: "hidden",
  borderRadius: "8px",
};
